export default "__VITE_ASSET__D$VqF96$__"